import styled from 'styled-components'

// Styled Component

import { S_ContentColumn } from '../../../../_components/layout/ContentColumn'
import { S_DropGallery } from '../../../../_components/FilesManager/views/DropGallery'
import { S_FileViewerInner } from '../../../../_components/FileViewer'
import { S_FilesManager, S_FilesManagerBrowser } from '../../../../_components/FilesManager'
import { S_ItemsOverview } from '../../../../_components/ItemsOverview'
import { S_NoteEditor } from '../../../../_components/Notes/NoteEditor'
import { S_NoteList } from '../../../../_components/Notes/NoteList'
import { textInputStyles } from '../../../../_constants/styles'

export const S_ScheduleDetailsPage = styled.div`
  ${S_ItemsOverview} {
    margin-bottom: 35px;
  }

  ${S_ContentColumn} {
    max-width: 100% !important;
  }
  .unprocess {
    margin-left: 16px;
  }
  .purchase-details {
    font-weight: bold;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 15px 0;
    .schedule-date {
      ${textInputStyles}
      margin-left: 16px;
    }
    .purchase-date {
      display: flex;
      align-items: center;
      .label {
        white-space: nowrap;
      }
    }
  }
  .controls {
    display: flex;
  }

  .cliploader-wrapper {
    min-width: 400px;
    display: flex;
    justify-content: center;
  }

  .btn-container {
    margin-left: 16px;
    display: flex;
  }
  .purchase-btn {
    cursor: pointer;
  }
  .reject-btn {
    background-color: #ee5555;
  }
  .reject-btn:disabled {
    cursor: not-allowed;
  }
  .button-row {
    display: flex;
    margin: 25px 0 0;
    justify-content: center;
  }
  .select-all-column {
    display: flex;
    justify-content: space-between;
    cursor: default;
  }
  label,
  .select-checkbox {
    cursor: pointer;
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
  .compact {
    max-height: 30px;
  }
  .approve-btn {
    margin-left: 16px;
  }
  ${S_FilesManager} {
    margin-top: 48px;
  }
  .purchase-btn {
    margin-right: 8px;
  }
`

export const S_FilesSidebar = styled.div`
  z-index: 8;
  .batch-file-container {
    border-style: solid;
    border-width: 1px;
    height: 100%;
    max-height: 90vh;
    border-color: #ddd;
    border-radius: 5px;
    padding: 5px;
    display: none;
    left: 100%;
    background-color: white;
    top: 5vh;
    position: fixed;

    img {
      cursor: grab;
    }
    canvas {
      cursor: grab;
    }
    .opener {
      position: absolute;
      width: 30px;
      height: 30px;
      left: -30px;
      background-color: white;
      cursor: pointer;
      border-top-style: solid;
      border-left-style: solid;
      border-bottom-style: solid;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      border-top-color: #ddd;
      border-bottom-color: #ddd;
      border-left-color: #ddd;
      border-width: 1px;
      padding-top: 5px;
      padding-left: 5px;
    }
  }
  .show-files {
    left: unset;
    right: 0;
    height: 90vh;
  }
  .slim-gallery-view {
    display: ${(props) => (props.galleryShown ? 'block' : 'none')};
  }
  .hide-files {
    max-height: 100px;
  }
  .overall-container {
    max-width: 100%;
    width: 100%;
  }
  ${S_FilesManager} {
    max-height: unset;
  }
  ${S_DropGallery} {
    max-height: 500px;
  }
  tr[draggable='true'] {
    cursor: grab;
  }
  tr[draggable='true']:active {
    cursor: grabbing;
  }
  @media screen and (min-width: 992px) {
    ${S_DropGallery} {
      .overall-container {
        max-width: 300px;
        width: 100%;
      }
    }
    .overall-container-expanded {
      max-width: 100%;

      ${S_FileViewerInner} {
        max-width: 100%;
      }
    }
    .batch-file-container {
      display: block;
      max-width: 40%;
    }
    ${S_FilesManager} {
      height: 100%;
      max-height: unset;
      ${S_FilesManagerBrowser} {
        height: calc(100% - 46px);
      }
    }
    ${S_DropGallery} {
      overflow-y: scroll;
      max-width: 100%;
      width: fit-content;
      overflow-x: hidden;
      display: flex;
      flex-wrap: wrap;
      max-height: 100%;
      margin: 0;

      &::-webkit-scrollbar {
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #ddd;
        border-radius: 10px;
      }
    }
  }
`

export const S_VerificationNotesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
`

export const S_VerificationDetails = styled.div`
  border: 1px solid #d0d0d0;
  border-radius: 5px;
  width: 49%;
  padding: 15px;
  margin-top: 10px;
`

export const S_GeneralNotes = styled.div`
  width: 49%;
  padding: 15px 15px 0 15px;
  margin-top: 10px;
  border: 1px solid #d0d0d0;
  border-radius: 5px;

  ${S_NoteList} {
    margin-top: 20px;
    max-height: 200px;
    overflow: scroll;
  }

  ${S_NoteEditor} {
    button {
      margin-left: auto;
    }
  }
`

export const S_VerificationDetailsContent = styled.div``

export const S_VerificationDetailsPieSection = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const S_VerificationRequirementSection = styled.div`
  padding: 20px;
`

export const S_NoVerificationData = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
  background-color: #efefef;
  width: 100%;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid #d7d7d7;
  color: #7f7f7f;
`

export const S_NoVerificationRequirement = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  background-color: #efefef;
  width: 100%;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid #d7d7d7;
  color: #7f7f7f;
`
